import { WorkforceActiveCompanyList } from 'src/app/shared/company-list-editor/company-list-editor.component';
import { SavedList } from './saved-lists.service';

export enum SavedListType {
  Companies = 'companies',
  RoleDefinition = 'role_definition',
}

export interface SavedListCompanyItem {
  id: string;
  name?: string;
  group?: boolean;
}

export function WorkforceActiveCompanyListToSavedList(
  list: WorkforceActiveCompanyList,
  category: string = ''
): SavedList {
  return {
    id: list.id || '',
    name: list.name,
    category: category,
    createdAt: new Date().toISOString(),
    createdBy: '',
    items: list.companies,
    itemType: SavedListType.Companies,
    scope: 'org',
  };
}
